import Message from '../components/Message';
import 'jquery-validation/dist/jquery.validate.min';

export default (function (w, d) {
    'use strict';

    let that;

    function CartController() {
        that = this;
        this.orderDetailsSaved = false;

        if ($("#card-element").length) {
            const stipeElements = stripePayment.elements({
                locale: window.Laravel.locale,
                appearance: {
                    theme: 'flat',
                    variables: { colorPrimaryText: '#292929' }
                }
            });

            // Set up Stripe.js and Elements to use in checkout form
            const style = {
                base: {
                    color: '#292929',
                    fontFamily: 'BryantPro, sans-serif',
                    fontSize: '18px',
                    fontWeight: '400',
                    lineHeight: '22px',
                    padding: '10px 20px 10px 20px'
                }
            };

            this.card = stipeElements.create("card", { style });
            this.card.mount("#card-element");
        }

        this.makeStickySidebarTillFooter();
        this.initController();
        this.displayInvoiceInformation();
        this.validateForm();
        this.checkCouponCode();
        this.chooseDeliveryMethod();
        this.initPaymentInfoBlockDisplay();
        this.initCheckoutForm();
    }

    CartController.prototype.initController = function () {
        $('#country').change(function () {
            if ($(this).val() === 'LT') {
                $('.foreign_delivery').hide();
                $('.local_delivery').show();
            } else {
                $('.local_delivery').hide();
                $('.foreign_delivery').show()
                    .find('input').prop('checked', true).trigger('change');
            }
        });

        $('.radio-box-shipping').click(function () {
            if ($(this).find('input').hasClass('delivery_methods')) {
                // $('.address_inputs').show();
                $('.address_details').hide();
            } else {
                // $('.address_inputs').hide();
                $('.address_details').show();
            }
            $(this).children('input').prop('checked', true).trigger('change');
            $('.radio-box-shipping.selected').removeClass('selected');
            $(this).closest('.radio-box-shipping').addClass('selected');
        });

        $('.radio-box-payment').click(function () {
            $(this).children('input').prop('checked', true);
            $(this).children('input').trigger('change');
            $('.radio-box-payment.selected').removeClass('selected');
            $(this).closest('.radio-box-payment').addClass('selected');
        });

        $(document).on('click', '.step-container .remove', function (e) {
            e.preventDefault();
            var $this = $(this);
            var items_count = $this.parent().parent().parent().siblings().length + 1;
            $(this).parent().parent().parent().animate({
                'height': "0px",
                'padding': "0px",
            }, 500, function () {
                $(this).parent().css({"border": "none", "padding": "0", "margin-top": "-20px"});

                var product_id = $this.attr('data-id');
                var url = $this.attr('data-url');
                var home_url = $this.attr('data-home');

                $.ajaxSetup({
                    headers: {
                        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                    }
                });

                $.post(url, {product_id: product_id}, function (response) {
                    if (response.total_cart_products <= 0) {
                        window.location.href = "/";
                    }
                    $('.product_total').text(response.total_cart_products);
                    $('.cart_sum').text(response.total_products_sum);
                    $('.discount_all').text(response.total_cart_discount);
                    $('.total_sum').text(response.total_cart_sum);
                    if (response.product_in_order && response.product_in_order.length === 0) {
                        $('.button.checkout').prop("disabled", false);
                    }
                });

                $(this).remove();
            });
        });
    }

    CartController.prototype.displayInvoiceInformation = function () {
        $('#invoice').change(function () {
            $('#invoice-information').toggle();
        });
    }

    CartController.prototype.validateForm = function () {
        $(document).ready(function () {
            let form = $(".customer-details-form");
            form.validate({
                rules: {
                    email: {
                        required: true,
                        email: true
                    },
                    firstname: {
                        required: true,
                    },
                    lastname: {
                        required: true,
                    },
                    // phone: {
                    //     required: false,
                    //     phoneNumber: true
                    // },
                    company: {
                        required: function () {
                            return !!$("#invoice").is(':checked');
                        }
                    },
                    company_code: {
                        required: function () {
                            return !!$("#invoice").is(':checked');
                        }
                    },
                    company_address: {
                        required: function () {
                            return !!$("#invoice").is(':checked');
                        }
                    },
                    company_vat: {
                        required: function () {
                            return !!$("#invoice").is(':checked');
                        }
                    },
                    privacy_agree: {
                        required: true
                    },
                    country: {
                        required: true
                    },
                    city: {
                        required: true
                    },
                    address: {
                        required: true
                    },
                    postcode: {
                        required: true
                    }
                },
                highlight: function (element) {
                    $(element).parent().addClass('has-error');
                },
                unhighlight: function (element) {
                    $(element).parent().removeClass('has-error');
                },
                messages: window.checkoutErrorMessage ? {
                    firstname: window.checkoutErrorMessages['enterFirstName'],
                    lastname: window.checkoutErrorMessages['enterLastName'],
                    email: window.checkoutErrorMessages['enterEmail'],
                    company: window.checkoutErrorMessages['enterCompanyName'],
                    company_code: window.checkoutErrorMessages['enterCompanyCode'],
                    company_address: window.checkoutErrorMessages['enterCompanyAddress'],
                    company_vat: window.checkoutErrorMessages['enterCompanyVat'],
                    country: window.checkoutErrorMessages['enterCountry'],
                    city: window.checkoutErrorMessages['enterCity'],
                    address: window.checkoutErrorMessages['enterAddress'],
                    postcode: window.checkoutErrorMessages['enterPostcode'],
                    shipping: window.checkoutErrorMessages['chooseShipping'],
                    payment: window.checkoutErrorMessages['choosePayment'],
                    privacy_agree: window.checkoutErrorMessages['checkPrivacyAgree'],
                } : null,
                submitHandler: function (form) {
                    return true;
                }
            });

            $.validator.addMethod("phoneNumber", function (phone_number, element) {
                return phone_number.match(/^(?=.*[0-9])[- +()0-9]+$/)
            }, window.checkoutErrorMessages ? window.checkoutErrorMessages['enteredNumberIsIncorrect'] : 'Entered number is incorrect',);
        });
    }

    CartController.prototype.checkCouponCode = function () {
        let coupon_request;

        $('.js-add-coupon').click(function (e) {
            e.preventDefault();
            if (coupon_request) coupon_request.abort();

            let couponField = $('#coupon');
            let coupon = couponField.val();
            let url = couponField.attr("data-url");
            let crsf = couponField.attr("data-csrf");
            let cart_total_url = $('#cart-price').data('cart-total-url');
            let args = {
                coupon: coupon,
                _token: crsf
            };

            coupon_request = $.post(url, args, function (res) {
                $('#discount-line').html(res.html ?? '');
                $('#discount-line-d').html(res.html ?? '');

                if (res.status === 'error' || res.status === 'success') {
                    new Message(res.message, res.status);
                }
                if (res.product_sum) {
                    $('.cart_sum').text(res.product_sum);
                }
            }).fail(function (jqXHR) {
                fail(jqXHR);
                $('#discount-line').html('');
                $('#discount-line-d').html('');
            }).always(function () {
                $.get(cart_total_url, {}, function (res) {
                    $('#cart-price').text(res.total);
                    $('#cart-price-mob').text(res.total);
                });
            });
        });
    }

    CartController.prototype.chooseDeliveryMethod = function () {
        let deliveryMethodRequest;
        $('.radio-box-shipping input').on('change', function (e) {
            e.preventDefault();
            if (deliveryMethodRequest) deliveryMethodRequest.abort();
            let deliveryMethodID = $('input[name=shipping]:checked', '.radio-box-shipping').val();
            let url = '/choose-delivery';
            let cartField = $('#cart-price');
            let cartFieldMobile = $('#cart-price-mob');
            let cart_total_url = cartField.data('cart-total-url');
            let deliveryField = $('#delivery-price');
            let deliveryFieldMobile = $('#delivery-price-mob');
            let args = { deliveryMethodID };

            deliveryMethodRequest = $.post(url, args, function (response) {
                if (response.total_price && response.delivery_price) {
                    deliveryField.text(response.delivery_price);
                    deliveryFieldMobile.text(response.delivery_price);
                    cartField.text(response.total_price);
                    cartFieldMobile.text(response.total_price);
                }
                if (response.status === 'error') {
                    new Message(response.message, response.status);
                    location.reload();
                }
                if (response.status === 'success') {
                    new Message(response.message, response.status);
                }
            }).always(function () {
                $.get(cart_total_url, {}, function (response) {
                    cartField.text(response.total_price);
                    cartFieldMobile.text(response.total_price);
                });
            });
        });
    }

    CartController.prototype.makeStickySidebarTillFooter = function () {
        $(function () {
            let sidebar = $('.sidebar');
            if (sidebar.length) {
                let stickyTop = sidebar.offset().top;
                let stickyHeight = sidebar.height();
                if (window.innerHeight) {
                    $(window).scroll(function () {
                        let limit = $('.footer').offset().top - stickyHeight - 50;
                        let windowTop = $(window).scrollTop();

                        if (stickyTop < windowTop) {
                            sidebar.css({position: 'fixed', top: 70});
                        } else {
                            sidebar.css('position', 'static');
                        }

                        if (limit < windowTop) {
                            let diff = limit - windowTop;
                            sidebar.css({top: diff});
                        }
                    });
                }
            }
        });
    }

    CartController.prototype.initPaymentInfoBlockDisplay = function () {
        $('input[name="payment"]').change(function () {
            if ($(this).attr('id') === 'stripe') {
                $('.stripe-payment-block').show();
            } else {
                $('.stripe-payment-block').hide();
            }

            if ($(this).attr('id') === 'bank-transfer') {
                $('#requisites').show();
            } else {
                $('#requisites').hide();
            }
        });
    }

    CartController.prototype.initCheckoutForm = function () {
        const form = d.querySelector('.customer-details-form');

        if (form !== null) {
            form.addEventListener('submit', (e) => {
                e.preventDefault();
                $('#card-errors').text('');

                const formData = $(form).serialize();
                const url = form.action;

                $.ajax({
                    method: 'POST',
                    url: url,
                    data: formData,
                    success: function (response) {
                        if (!response.success) {
                            new Message(response.message, 'error');
                            return;
                        }

                        if (response.redirect_to !== undefined) {
                            window.location = response.redirect_to;
                        }

                        if (response.stripe_client_secret !== undefined && response.stripe_client_secret) {
                            that.submitStripeForm(response.stripe_client_secret);
                        }
                    },
                    error: function (response) {
                        new Message(response.responseJSON.message || response.responseJSON, 'error');
                    }
                });
            });
        }
    }

    CartController.prototype.submitStripeForm = function (client_secret) {
        const stripeForm = d.querySelector('.stripe-payment-block');
        stripeForm.classList.add('spinner');
        const cardHolder = stripeForm.querySelector('#cardHolder').value;
        const cardEmail = stripeForm.querySelector('#cardEmail').value;

        stripePayment.confirmCardPayment(client_secret, {
            payment_method: {
                card: that.card,
                billing_details: {
                    name: cardHolder,
                    email: cardEmail
                }
            },
            setup_future_usage: 'off_session'
        }).then((result) => {
            stripeForm.classList.remove('spinner');

            if (result.error) {
                $('#card-errors').text(result.error.message);
            } else {
                if (result.paymentIntent.status === 'succeeded') {
                    $('#card-success').show();

                    let data = new FormData();
                    data.append('paymentIntentId', result.paymentIntent.id);

                    that.completeStripePayment(stripeForm, data);
                }
            }
        });
    }

    CartController.prototype.completeStripePayment = function (stripeForm, body) {
        fetch(stripeForm.dataset.notifyUrl, {method: 'POST', body})
            .then(response => response.text())
            .then(text => {
                try {
                    const data = JSON.parse(text);

                    if (!data.success) {
                        const errorBlock = d.querySelector('#card-errors');
                        errorBlock.innerHTML = data.message;
                        stripeForm.classList.remove('spinner');
                        return;
                    }

                    if (data.redirect_to !== undefined) {
                        window.location = data.redirect_to;
                    }
                } catch(err) {
                    new Message('An error occurred while processing your payment. Contact the administrator', 'error');
                }
            });
    }

    return CartController;
}(window, document));

